
<template>
  <div>
    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <template v-if="!loading">
      <v-card scrollable flat>
        <select-time class="py-2"></select-time>
        <v-divider></v-divider>
        
        <v-card-text style="height: 83vh; overflow-y:auto">
          <employee-table v-if="current_execution.kind == 'model_1'"></employee-table>
          <category-table v-if="current_execution.kind == 'model_2'"></category-table>
        </v-card-text>
        <v-speed-dial
          v-model="fab"
          app
          style="z-index: 0; position: absolute; right: 10px; top: 95%"
          direction="left"
          transition="scale-transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab >
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>
          <v-btn dark small color="green" @click="finishExecution()" >
            <v-icon left @click="finishExecution()">mdi-content-save</v-icon> finalizar
          </v-btn>
          <v-btn dark small color="indigo" @click="dialog_comment = true">
            <v-icon left>mdi-chat</v-icon> comentar
          </v-btn>
        </v-speed-dial>
      </v-card>
    </template>

    <dialog-comments :dialog="dialog_comment" @closeComment="handleCloseComment"></dialog-comments>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ShowExecution',
  components: {
    SelectTime: () => import('./SelectTime.vue'),
    EmployeeTable: () => import('./model_1/EmployeeTable.vue'),
    CategoryTable: () => import('./model_2/CategoryTable.vue'),
    DialogComments: () => import('./DialogComments.vue'),
  },
  data() {
    return {
      loading: false,
      fab: false,
      dialog_comment: false,
      time_spacing: {
        value: 20,
        unit: 'minutes',
      },
    }
  },
  mounted() {
    this.setupExecution();
  },
  beforeDestroy() {
    this.clearCurrentExecution();
  },
  methods: {
    handleCloseComment(){
      this.dialog_comment = false
    },
    async finishExecution() {
      try {
        let job_interval_end = this.current_execution.date.split('T')[0]
        job_interval_end = job_interval_end + ' ' + this.current_execution.job_interval.end;
        job_interval_end = this.$dayjs(job_interval_end)
        
        let ans1 = await this.endExecSwal1();
        if (ans1) {
          let ans2 = true;
          if (this.$dayjs(this.$dayjs()).diff(job_interval_end) < 0) {
            ans2 = await this.endExecSwal2();
          }
          if (ans2) {
            this.endExecution().then(() => {
              this.$router.push({name: 'ExecutionList'})
            });
          }
        }
      } catch (error) {
        throw error;
      }
    },
    async endExecSwal1() {
      return await this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: 'Deseja salvar medição?',
        text: 'Medições salvas não podem ser modificadas.',
        icon: 'question'
      }).then(r => r.isConfirmed)
    },
    async endExecSwal2() {
      return await this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: `Fim da jornada de trabalho marcado para ${this.current_execution.job_interval.end}`,
        text: 'Deseja ainda proseguir?',
        icon: 'question'
      }).then(r => r.isConfirmed)
    },
    async getExecution() {
      return await this.showExecution(this.$route.params.id);
    },
    async setupExecution() {
      this.loading = true;
      try {
        let exec = await this.getExecution();
        // this.setupInterval();
        exec = {
          ...exec,
          ...this.setupTimes()
        };
        if (exec.kind == 'model_1') {
          exec = {
            ...exec,
            employees: this.setupEmployees(exec)
          };
          this.setExecutionModel1(exec);
        } else {
          exec = {
            ...exec,
            categories: this.setupCategories(exec)
          };
          this.setExecutionModel2(exec);
        };
      } catch (error) {
        throw error;
      }
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    setupTimes(){
      let all_times_obj = []
      let all_times = []
      let today_day = this.$dayjs()
      let last_time = this.$dayjs().startOf('day')
      // console.log({...last_time})
      if (this.current_exec_has_interval_set) {
        last_time = last_time.add( this.current_execution.job_interval.start.split(':')[0],'hours')
        last_time = last_time.add( this.current_execution.job_interval.start.split(':')[1],'minutes')
        // console.log({...last_time});
      } 
      while (last_time.date() == today_day.date() && (this.current_exec_has_interval_set && Number(last_time.format('HH') )< Number(this.current_execution.job_interval.end.split(':')[0]) ) ){
        all_times_obj.push(last_time)
        all_times.push(last_time.format('HH:mm'))
        last_time = last_time.add(this.time_spacing.value, this.time_spacing.unit)
        // console.log(Number(last_time.format('HH') ), Number(this.current_execution.job_interval.end.split(':')[0]));
        // console.log(Number(last_time.format('HH') ) < Number(this.current_execution.job_interval.end.split(':')[0]));
      }
      if (Number(last_time.format('HH') ) == Number(this.current_execution.job_interval.end.split(':')[0])){
        all_times_obj.push(last_time)
        all_times.push(last_time.format('HH:mm'))
      }
      this.setCurrentTime(all_times[0])
      this.setCurrentTimeIdx(0)
      return {all_times_obj, all_times}
    },
    setupEmployees(exec){
      let employees = [...exec.employees];
      employees.map(employee => {
        employee.grade_time = employee.grade_time.length ? employee.grade_time : Array(exec.all_times.length).fill(0);
      })
      return employees
    },
    setupCategories(exec) {
      let categories = [...exec.categories];
      categories.map(category => {
        category.grade_time = category.grade_time?.length ? category.grade_time : Array(exec.all_times.length).fill(0);
      })
      return categories
    },
    // setupInterval(){
    //   let start = '07:00'
    //   let end = '17:00'
    //   this.setExecutionInterval({start, end})
    // },
    showExecutionConfig(){},
    ...mapMutations({
      setExecutionInterval: 'Execution/setExecutionInterval',
      setExecutionModel1: 'Execution/setExecutionModel1',
      setExecutionModel2: 'Execution/setExecutionModel2',
      setCurrentTime: 'Execution/setCurrentTime',
      setCurrentTimeIdx: 'Execution/setCurrentTimeIdx',
      clearCurrentExecution: 'Execution/clearCurrentExecution'
    }),
    ...mapActions({
      showExecution: 'Execution/showLocalExecution',
      updateExecution: 'Execution/updateExecution',
      endExecution: 'Execution/endExecution'
    })
  },
  computed: {
    current_exec_has_interval_set() {
      if (this.current_execution){
        if (this.current_execution.job_interval.start && this.current_execution.job_interval.end){
          return true
        }
      }
      return false 
    },
    ...mapState({
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      profile: state => state.User.profile,
      exec_model_1: state => state.Execution.exec_model_1
    }),
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>